export function camelCaseToSentance(camelCaseStr) {
  return camelCaseStr
    .replace(/([A-Z])/g, " $1") // Add space before capital letters
    .replace(/^./, (match) => match.toUpperCase()); // Capitalize the first letter
}
